<div [ngSwitch]="componentId" *ngIf="data">
  <app-hro-coaches *ngSwitchCase="'COACHES'" [data]="data"></app-hro-coaches>
  <app-hro-b2b-customer *ngSwitchCase="'B2B_CUSTOMERS'" [data]="data"></app-hro-b2b-customer>
  <app-hro-testimonial *ngSwitchCase="'TESTIMONIALS'" [data]="data"></app-hro-testimonial>
  <app-hro-journey-to-excellence
    *ngSwitchCase="'JOURNEY_TO_EXCELLENCE' || 'JOURNEY_TO_EXCELLENCE_BENEFICIARY'"
    [data]="data"></app-hro-journey-to-excellence>
</div>
